import React, { createContext, useContext, useState } from 'react';

const SizePreferenceContext = createContext();

function loadPref() {
  try { return localStorage.getItem('binco_size_pref') || ''; }
  catch { return ''; }
}

export function SizePreferenceProvider({ children }) {
  const [sizePreference, setSizePreference] = useState(loadPref);

  function setPref(size) {
    setSizePreference(size);
    localStorage.setItem('binco_size_pref', size);
  }

  return (
    <SizePreferenceContext.Provider value={{ sizePreference, setSizePreference: setPref }}>
      {children}
    </SizePreferenceContext.Provider>
  );
}

export function useSizePreference() {
  return useContext(SizePreferenceContext);
}
